import { render } from "./SendersEditComponent.vue?vue&type=template&id=10d08fe2&scoped=true"
import script from "./SendersEditComponent.vue?vue&type=script&lang=js"
export * from "./SendersEditComponent.vue?vue&type=script&lang=js"

import "./SendersEditComponent.vue?vue&type=style&index=0&id=10d08fe2&scoped=true&lang=scss"

import exportComponent from "/Users/dmitriy-pc/Projects/docs.d-services.ru/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-10d08fe2"]])

export default __exports__